import type {
  DepositColumns,
  MethodColumns,
  WithdrawalColumns
} from '@library/types/payments';
import type { TableColumn } from '@library/types/utils';

export const DEPOSITS_HEADER_INFO: Array<TableColumn<DepositColumns>> = [
  {
    column: 'user',
    essential: true,
    label: 'User',
    shortenedLabel: 'User',
    sortEnabled: false
  },
  {
    column: 'paymentId',
    essential: true,
    label: 'Payment ID',
    shortenedLabel: 'PID',
    sortEnabled: false
  },
  {
    column: 'created',
    essential: true,
    label: 'Created At',
    shortenedLabel: 'Created',
    sortEnabled: false
  },
  {
    column: 'amount',
    essential: true,
    label: 'Amount',
    shortenedLabel: 'Amount',
    sortEnabled: false
  },
  {
    column: 'method',
    essential: true,
    label: 'Method',
    shortenedLabel: 'Method',
    sortEnabled: false
  },
  {
    column: 'state',
    essential: true,
    label: 'State',
    shortenedLabel: 'State',
    sortEnabled: false
  },
  {
    column: 'status',
    essential: true,
    label: 'Status',
    shortenedLabel: 'Status',
    sortEnabled: false
  }
];

export const METHODS_HEADER_INFO: Array<TableColumn<MethodColumns>> = [
  {
    column: 'method',
    essential: true,
    label: 'Method',
    shortenedLabel: 'Method',
    sortEnabled: false
  },
  {
    column: 'last4',
    essential: true,
    label: 'Last 4 Digits',
    shortenedLabel: 'Last4',
    sortEnabled: false
  },
  {
    column: 'expiration',
    essential: true,
    label: 'Expiration',
    shortenedLabel: 'Exp',
    sortEnabled: false
  },
  {
    column: 'zip',
    essential: true,
    label: 'Zip',
    shortenedLabel: 'Zip',
    sortEnabled: false
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    shortenedLabel: 'Name',
    sortEnabled: false
  },
  {
    column: 'actions',
    essential: true,
    label: 'Actions',
    shortenedLabel: 'actions',
    sortEnabled: false
  }
];

export const WITHDRAWALS_HEADER_INFO: Array<TableColumn<WithdrawalColumns>> = [
  {
    column: 'user',
    essential: true,
    label: 'User',
    shortenedLabel: 'User',
    sortEnabled: false
  },
  {
    column: 'id',
    essential: true,
    label: 'Payment ID',
    shortenedLabel: 'ID',
    sortEnabled: false
  },
  {
    column: 'created',
    essential: true,
    label: 'Created At',
    shortenedLabel: 'Created',
    sortEnabled: false
  },
  {
    column: 'amount',
    essential: true,
    label: 'Amount',
    shortenedLabel: 'Amount',
    sortEnabled: false
  },
  {
    column: 'method',
    essential: true,
    label: 'Method',
    shortenedLabel: 'Method',
    sortEnabled: false
  },
  {
    column: 'state',
    essential: true,
    label: 'State',
    shortenedLabel: 'State',
    sortEnabled: false
  },
  {
    column: 'status',
    essential: true,
    label: 'Status',
    shortenedLabel: 'Status',
    sortEnabled: false
  }
];
